module.exports = __webpack_public_path__ + "img/dana-farber_logo.da47c5e8.png";